/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LocalTime } from './LocalTime';
export type CalendarBlockDto = {
    id?: number;
    date?: string;
    startTime?: LocalTime;
    endTime?: LocalTime;
    reason?: CalendarBlockDto.reason;
    teamId?: number;
    createdAt?: string;
};
export namespace CalendarBlockDto {
    export enum reason {
        TRAINING_UNIT = 'TRAINING_UNIT',
        PRESEASON_GAME = 'PRESEASON_GAME',
        PRESEASON_UNAVAILABLE = 'PRESEASON_UNAVAILABLE',
    }
}

